const RoutePaths = {
	home: "/",
	project: "/project",
	poolDetails: "/pool-details",
};

export default RoutePaths;
